import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import MyLogsForm from './Form'

export default function MyLogsFormIndex({ mentorshipId }) {
  const { id } = useParams()
  const list = useSelector(state => state.mentorship.log.list)
  const log = id === 'new' ? null : list?.find(l => String(l.id) === id)
  return <MyLogsForm log={log} mentorshipId={mentorshipId} />
}
